import axios from 'axios';
import { AssistButtonAction, AssistButtonDeferredAction, AssistReason, AssistResponse } from '../types';

axios.defaults.baseURL = process.env.APP_API_URL;

const fetchButton = async ({ requestId }, { signal }): Promise<AssistResponse> => {
  const response = await axios.get(`/v1/assist/requests/${requestId}/button`, { signal });
  return response.data;
};

const fetchBackgroundUpdate = async ({ requestId }, { signal }): Promise<AssistResponse> => {
  const response = await axios.get(`/v1/assist/requests/${requestId}/background_update`, { signal });
  return response.data;
};

const fetchModal = async (
  {
    requestId,
    requestStatus,
    action,
    reason,
    message,
    deferredAction,
    username,
    isDashboard,
  }: {
    requestId: number;
    requestStatus: string;
    action: AssistButtonAction;
    reason?: AssistReason;
    message?: string;
    deferredAction: AssistButtonDeferredAction;
    username: string;
    isDashboard: number;
  },
  { signal }
): Promise<AssistResponse> => {
  let method = 'get';
  const params: { action?: AssistButtonDeferredAction } = {};

  let data: {
    action?: AssistButtonAction;
    user_name?: string;
    is_dashboard?: boolean;
    reason?: AssistReason;
    message?: string;
    deferred_action?: AssistButtonDeferredAction;
    status?: string;
  } = {};

  if (['next', 'complaint', 'solved'].includes(action)) {
    method = 'post';
  } else if (['cancel'].includes(action)) {
    method = 'delete';
  } else if (['button', 'help', 'reason'].includes(action)) {
    method = 'get';
  }

  if (action === 'complaint') {
    data = {
      reason,
      message,
      action,
      deferred_action: deferredAction,
      status: requestStatus,
    };
  }

  if (action === 'reason') {
    params.action = deferredAction;
  }

  if (['next', 'cancel'].includes(action)) {
    data.user_name = username;
    data.is_dashboard = !!isDashboard;
  }

  const response: { data: AssistResponse } = await axios(`/v1/assist/requests/${requestId}/${action}`, {
    params,
    data,
    method,
    signal,
  });

  if (response.data?.render_type === 'popup_help' && response.data.content?.reasons?.length) {
    response.data.render_type = 'popup_reason';
  }
  if (response.data.content) {
    response.data.content.title = response.data.content.title ?? '';
  }

  return response.data;
};

export default { fetchButton, fetchModal, fetchBackgroundUpdate };
